import PrivateTermsContent from "./PrivateTermsContent";

export default function privacyTermsPage() {
    return <div>
        <h1>개인정보 처리방침</h1>
        <PrivateTermsContent/>
    </div>
}